"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var form_control_service_1 = require("../../services/form-control.service");
var forms_1 = require("@angular/forms");
var form_field_display_type_enum_1 = require("@chatForm/src/app/models/form-field-display-type.enum");
var FormFieldComponent = /** @class */ (function () {
    function FormFieldComponent(formControlService) {
        this.formControlService = formControlService;
        this.FieldDisplayType = form_field_display_type_enum_1.FormFieldDisplayType;
        this.resources = resources;
    }
    Object.defineProperty(FormFieldComponent.prototype, "formControl", {
        get: function () { return this.form.controls[this.field.rowId]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormFieldComponent.prototype, "isRequired", {
        get: function () { return this.formControlService.isRequiredControl(this.formControl); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormFieldComponent.prototype, "invalid", {
        get: function () { return this.formControl.invalid; },
        enumerable: true,
        configurable: true
    });
    FormFieldComponent.prototype.ngOnInit = function () { };
    FormFieldComponent.prototype.getName = function (row) {
        if (row.fieldTypeName === "Custom" || row.fieldTypeName === "Dropdown") {
            return "Parameters[ChatParam_" + row.mappingFieldName + "]";
        }
        return row.mappingFieldName;
    };
    FormFieldComponent.prototype.getFieldDisplayType = function (row) {
        if (row.options && row.options.length)
            return form_field_display_type_enum_1.FormFieldDisplayType.Dropdown;
        if (row.mappingFieldName === 'Email')
            return form_field_display_type_enum_1.FormFieldDisplayType.Email;
        return form_field_display_type_enum_1.FormFieldDisplayType.PlainText;
    };
    FormFieldComponent.prototype.getOptionLabel = function (option) {
        return option.optionLanguages[0].optionLabel;
    };
    FormFieldComponent.prototype.getOptionTooltip = function (option) {
        var label = this.getOptionLabel(option);
        return label.length > 45 ? label : '';
    };
    return FormFieldComponent;
}());
exports.FormFieldComponent = FormFieldComponent;
